import { render, staticRenderFns } from "./IconMinus.vue?vue&type=template&id=db66a560&"
import script from "./IconMinus.vue?vue&type=script&lang=js&"
export * from "./IconMinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ebenhafkamp/Documents/Projects/tacpro/src/webpack/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db66a560')) {
      api.createRecord('db66a560', component.options)
    } else {
      api.reload('db66a560', component.options)
    }
    module.hot.accept("./IconMinus.vue?vue&type=template&id=db66a560&", function () {
      api.rerender('db66a560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/icons/IconMinus.vue"
export default component.exports